import HandDominanceSelect from './HandDominanceSelect';

export default HandDominanceSelect;
